module.exports = __webpack_public_path__ + "static/media/thumb.a10a9024.jpg";